(function(){
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function initCard(card){
    var gal = card.querySelector('.pc-gal');
    if(!gal) return;
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.pc-img'));
    if(imgs.length < 2) return;
    var i = 0, moved = false, lastWheel = 0;

    function show(n){
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function(im, k){ im.classList.toggle('is-on', k === i); });
    }
    show(0);

    if(fine){
      card.addEventListener('mouseenter', function(){ show(1); });
      card.addEventListener('mouseleave', function(){ show(0); });
    }

    gal.querySelectorAll('.pc-arrow').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        show(i + (a.classList.contains('pc-next') ? 1 : -1));
      });
    });

    var x0 = null, dragging = false;
    gal.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX; dragging = true; moved = false;
    });
    gal.addEventListener('pointermove', function(e){
      if(!dragging) return;
      var dx = e.clientX - x0;
      if(Math.abs(dx) > 34){ show(i + (dx < 0 ? 1 : -1)); x0 = e.clientX; moved = true; }
    });
    ['pointerup','pointercancel'].forEach(function(ev){
      gal.addEventListener(ev, function(){ dragging = false; });
    });

    gal.addEventListener('wheel', function(e){
      if(Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 14) return;
      e.preventDefault();
      var now = Date.now();
      if(now - lastWheel < 240) return;
      lastWheel = now;
      show(i + (e.deltaX > 0 ? 1 : -1));
    }, {passive:false});

    var link = card.querySelector('.prod-link');
    if(link){
      link.addEventListener('click', function(e){
        if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }
  }

  function initFilters(){
    var root = document.getElementById('colFilters');
    if(!root || root.__ddInit) return;
    root.__ddInit = 1;
    var dds = Array.prototype.slice.call(root.querySelectorAll('.cf-dd'));
    if(!dds.length) return;

    function closeAll(){
      dds.forEach(function(d){
        d.classList.remove('open');
        var t = d.querySelector('.cf-trigger');
        if(t) t.setAttribute('aria-expanded','false');
      });
    }

    dds.forEach(function(dd){
      var trig = dd.querySelector('.cf-trigger');
      if(!trig) return;
      trig.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var was = dd.classList.contains('open');
        closeAll();
        if(!was){ dd.classList.add('open'); trig.setAttribute('aria-expanded','true'); }
      });
    });

    document.addEventListener('click', function(e){
      if(!e.target.closest || !e.target.closest('.cf-dd')) closeAll();
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeAll(); });

    function refresh(){
      dds.forEach(function(dd){
        var on = dd.querySelectorAll('.cf-chip.active, .cf-chip.is-active, .cf-chip.on, .cf-chip[aria-pressed="true"]').length;
        var t = dd.querySelector('.cf-trigger');
        if(!t) return;
        var b = t.querySelector('.cf-n');
        if(on > 0){
          if(!b){ b = document.createElement('b'); b.className = 'cf-n'; t.insertBefore(b, t.querySelector('svg')); }
          b.textContent = on;
          dd.classList.add('has-on');
        } else {
          if(b) b.parentNode.removeChild(b);
          dd.classList.remove('has-on');
        }
      });
    }
    root.addEventListener('click', function(){ setTimeout(refresh, 30); });
    refresh();
  }

  function run(){
    document.querySelectorAll('.prod-card').forEach(function(c){
      if(c.__pcInit) return;
      c.__pcInit = 1;
      initCard(c);
    });
    initFilters();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  var t = null;
  new MutationObserver(function(){
    if(t) return;
    t = setTimeout(function(){ t = null; run(); }, 150);
  }).observe(document.documentElement, {childList:true, subtree:true});
})();